










import { Component, Vue, Prop, Watch, Provide } from 'vue-property-decorator';
interface IButtonLoading {
    text: string;
    loading: boolean;
}
@Component({})
export default class ButtonLoading extends Vue implements IButtonLoading {
    @Prop() text!: string;
    @Prop() loading!: boolean;
    @Prop() iconPack!: string;
    @Prop() icon!: string;
    @Prop({ default: 'primary' }) color!: string;

    @Watch('loading')
    onLoading() {
        if (this.loading) {
            // @ts-ignore
            this.$vs.loading({
                background: this.color,
                color: '#fff',
                // @ts-ignore
                container: this.$refs.loadableButton.$el,
                scale: 0.45,
            });
        } else {
            // @ts-ignore
            this.$vs.loading.close('#button-with-loading > .con-vs-loading');
        }
    }
}
